import { FaCode, FaRobot, FaCloud, FaArrowRight, FaCheck, FaInfoCircle, FaServer } from 'react-icons/fa';
import { useState } from 'react';
import styles from './ServicesPreview.module.css';

const ServicesPreview = () => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const services = [
    {
      icon: <FaCode />,
      title: "Desarrollo Web",
      description: "Creamos sitios web modernos y responsivos que destacan tu marca.",
      features: [
        {
          name: "Diseño personalizado",
          description: "Creamos páginas web únicas que reflejan la identidad de tu empresa. Cada elemento visual está pensado para conectar con tus clientes y destacar entre la competencia."
        },
        {
          name: "Optimización SEO",
          description: "Hacemos que tu sitio aparezca en los primeros resultados de Google cuando tus clientes busquen tus productos o servicios, aumentando las visitas y ventas potenciales."
        },
        {
          name: "Experiencia de usuario única",
          description: "Diseñamos sitios fáciles de usar y navegar, donde los visitantes encuentran rápidamente lo que buscan, mejorando su satisfacción y aumentando las conversiones."
        }
      ]
    },
    {
      icon: <FaServer />,
      title: "Infraestructura",
      description: "Configuramos y gestionamos tu infraestructura en la nube de forma eficiente y segura.",
      features: [
        {
          name: "Configuración de servidores",
          description: "Implementamos y configuramos servidores optimizados para tus necesidades específicas, garantizando máxima seguridad, rendimiento y disponibilidad para tus aplicaciones."
        },
        {
          name: "Infraestructura como código (IaC)",
          description: "Automatizamos la creación y gestión de tu infraestructura mediante código, permitiendo despliegues consistentes, control de versiones y recuperación rápida ante desastres."
        },
        {
          name: "Arquitectura escalable",
          description: "Diseñamos sistemas que crecen con tu negocio, adaptándose automáticamente a picos de tráfico sin interrupciones y optimizando costos cuando la demanda es menor."
        }
      ]
    },
    {
      icon: <FaRobot />,
      title: "Automatizaciones",
      description: "Optimizamos tus procesos con soluciones automatizadas.",
      features: [
        {
          name: "Flujos de trabajo",
          description: "Convertimos tareas repetitivas en procesos automáticos. Es como tener un asistente digital que trabaja 24/7 sin errores, liberando a tu equipo para tareas más importantes."
        },
        {
          name: "Integración de sistemas",
          description: "Conectamos tus diferentes programas y aplicaciones para que compartan información automáticamente, eliminando la necesidad de introducir los mismos datos varias veces."
        },
        {
          name: "Eficiencia operativa",
          description: "Reducimos el tiempo y dinero invertidos en tareas rutinarias hasta en un 80%, permitiéndote hacer más con menos recursos y enfocarte en hacer crecer tu negocio."
        }
      ]
    },
    {
      icon: <FaCloud />,
      title: "DevOps",
      description: "Implementamos prácticas DevOps para mejorar tu desarrollo.",
      features: [
        {
          name: "CI/CD",
          description: "Automatizamos la forma en que las actualizaciones llegan a tus usuarios. Los cambios se prueban y publican de forma segura y rápida, sin interrupciones en el servicio."
        },
        {
          name: "Infraestructura como código",
          description: "Gestionamos tus servidores y sistemas mediante archivos de configuración, lo que permite crear entornos idénticos con un solo clic y recuperarte rápidamente ante fallos."
        },
        {
          name: "Monitoreo continuo",
          description: "Vigilamos constantemente el funcionamiento de tus sistemas para detectar y solucionar problemas incluso antes de que afecten a tus usuarios, garantizando un servicio ininterrumpido."
        }
      ]
    }
  ];

  const handleTooltipToggle = (serviceIndex, featureIndex) => {
    const tooltipId = `${serviceIndex}-${featureIndex}`;
    setActiveTooltip(activeTooltip === tooltipId ? null : tooltipId);
  };

  return (
    <section className={styles.servicesPreview}>
      <div className={styles.servicesContainer}>
        <div className={styles.sectionHeader}>
          <h2>Nuestros Servicios</h2>
          <p>Soluciones tecnológicas adaptadas a tus necesidades</p>
        </div>
        
        <div className={styles.servicesGrid}>
          {services.map((service, serviceIndex) => (
            <div key={serviceIndex} className={styles.serviceCard}>
              <div className={styles.iconContainer}>
                {service.icon}
              </div>
              <h3 className={styles.serviceTitle}>{service.title}</h3>
              <p className={styles.serviceDescription}>{service.description}</p>
              <ul className={styles.featuresList}>
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className={styles.featureItem}>
                    <FaCheck />
                    <span>{feature.name}</span>
                    <button 
                      className={styles.infoButton}
                      onMouseEnter={() => handleTooltipToggle(serviceIndex, featureIndex)}
                      onMouseLeave={() => handleTooltipToggle(serviceIndex, featureIndex)}
                      aria-label="Más información"
                    >
                      <FaInfoCircle />
                    </button>
                    {activeTooltip === `${serviceIndex}-${featureIndex}` && (
                      <div className={styles.tooltip}>
                        {feature.description}
                      </div>
                    )}
                  </li>
                ))}
              </ul>
              {/* Replace the anchor with a button or add a proper URL */}
              <button className={styles.learnMore} onClick={() => window.location.href = `/services/${service.title.toLowerCase().replace(/\s+/g, '-')}`}>
                Saber más <FaArrowRight />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;